import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const storeOptions = {
  state,
  getters,
  actions,
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ['rewards', 'rewards_fetched_at', 'rewards_user_id']
  }
}

export const useRewardsStore = defineStore('rewards', storeOptions)
